export default __webpack_public_path__ + "static/media/slack-logo.583f244f.svg";